import * as Debug from 'debug';
import * as qs from 'query-string';
import * as React from 'react';
import { useEffect, useLayoutEffect, useState } from 'react';
import { IS_SERVER } from '../../common/constants';
import { MARKET } from '../../config/browser';
import { NewsletterProps } from './Newsletter.props';
import { StyledNewsletter, StyledNewsletterLoader } from './Newsletter.styles';

const debug = Debug('app:cmp:Newsletter');

const newsletterIframeId = 'newsletter-iframe';
const defaultIframeHeight = 800; // US form height on desktop

const getCountryCode = (text: string): string => {
  const lines = text.split('\n');
  for (const line of lines) {
    const [key, value] = line.split('=');
    if (key === 'loc') {
      const decodedValue = decodeURIComponent(value || '');
      if (decodedValue !== 'XX') {
        return decodedValue;
      }
    }
  }

  return '';
};

export const Newsletter = ({ collapsePadding = false, iFrameHeight = defaultIframeHeight, url }: NewsletterProps) => {
  const [isLoaderVisible, setIsLoaderVisible] = useState<boolean>(true);
  const [countryCode, setCountryCode] = useState<string | undefined>();

  const [myIframeHeight, setMyIframeHeight] = useState<number | { mobile: number; tablet: number; desktop: number }>(
    iFrameHeight,
  );

  useEffect(() => {
    (async () => {
      if (!url) {
        try {
          const res = await fetch('/cdn-cgi/trace');
          const text = await res.text();
          const code = getCountryCode(text);
          setCountryCode(code || MARKET);
        } catch (err) {
          debug(err);
          setCountryCode(MARKET);
        }
      }
    })();
  }, []);

  useLayoutEffect(() => {
    if (!isLoaderVisible) {
      const iframe = document.getElementById(newsletterIframeId);
      if (iframe) {
        iframe.style.display = 'block';
        window.scrollTo(0, 0);
      }
    }
  }, [isLoaderVisible]);

  useLayoutEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (typeof event.data !== 'object') return;
      if (event.data.type === 'scrollToTop') {
        window.scrollTo(0, 0);
      }
      if (event.data.type === 'iFrameResize') {
        setMyIframeHeight(event.data.height);
      }
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, [setMyIframeHeight]);

  const showForm = () => {
    setIsLoaderVisible(false);
  };

  let isReadyToFetch;
  let iframeUrl;
  if (IS_SERVER) {
    isReadyToFetch = false;
    iframeUrl = '';
  } else {
    const currentParams = qs.parse(window.location.search);

    let iframeParams;
    if (url) {
      isReadyToFetch = true;
      iframeUrl = url;
      const urlParams = qs.parseUrl(url).query;
      iframeParams = { ...urlParams, ...currentParams };
    } else {
      isReadyToFetch = typeof countryCode === 'string';
      iframeUrl = 'https://pages.warnerbros.com/wb-newsletter';
      iframeParams = currentParams;
      if (countryCode) {
        iframeParams.country = countryCode;
      }
    }

    const queryStr = qs.stringify(iframeParams);
    if (queryStr) {
      iframeUrl += `?${queryStr}`;
    }
  }

  return (
    <StyledNewsletter collapsePadding={collapsePadding} iFrameHeight={myIframeHeight}>
      <div className='content'>
        <StyledNewsletterLoader isVisible={isLoaderVisible} />
        {isReadyToFetch && <iframe id={newsletterIframeId} onLoad={showForm} src={iframeUrl} title='Newsletter' />}
      </div>
    </StyledNewsletter>
  );
};
